export default __webpack_public_path__ + "static/media/down-black.f906aafe.svg";